"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "canStartStream", {
  enumerable: true,
  get: function get() {
    return _canStartStream["default"];
  }
});
Object.defineProperty(exports, "streamEndpoints", {
  enumerable: true,
  get: function get() {
    return _streamEndpoints["default"];
  }
});
var _streamEndpoints = _interopRequireDefault(require("./streamEndpoints"));
var _canStartStream = _interopRequireDefault(require("./canStartStream"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }